import {updateObject} from "../../shared/utils/updateObject";
import * as actionTypes from "../actionTypes";
import {initialBulkCardsState, initialBulkDetailsState, initialPlanOptionsForSim, initialTokenOptions} from "./helper";

const initialState = {
    selectedTab: 0,
    bulkCard: initialBulkCardsState,
    bulkDetails: initialBulkDetailsState,
    planOptionsForSim: initialPlanOptionsForSim,
    tokenOptions: initialTokenOptions,
    downloadCsvLoading: false
};

const setBulkCardData = (state, action) => {
    return updateObject(state, {bulkCard: updateObject(state.bulkCard, {data: action.payload})});
}

const setPlanOptionsAndCurrentOffer = (state, action) => {
    return updateObject(state, {
        planOptionsForSim: updateObject(state.planOptionsForSim, {
            items: action.availablePlans,
            currentOffer: action.currentOffer
        })
    })
}

const setLoadingPlanOptions = (state, action) => {
    return updateObject(state, {planOptionsForSim: updateObject(state.planOptionsForSim, {loading: action.value})})
}

const setOfferForNewPlan = (state, action) => {
    return updateObject(state, {
        planOptionsForSim: updateObject(state.planOptionsForSim,
            {
                selectedPlanOffer: updateObject(state.planOptionsForSim.selectedPlanOffer,
                    {data: action.data})
            })
    })
}

const setLoadingOfferForNewPlan = (state, action) => {
    return updateObject(state, {
        planOptionsForSim: updateObject(state.planOptionsForSim,
            {
                selectedPlanOffer: updateObject(state.planOptionsForSim.selectedPlanOffer,
                    {loading: action.value})
            })
    })
}

const setLoadingBulkCards = (state, action) => {
    return updateObject(state, {
        bulkCard: updateObject(state.bulkCard, {loading: action.value})
    })
}

const setBulkDetailsContent = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            bulk: updateObject(state.bulkDetails.bulk, {content: action.data})
        })
    })
}

const setBulkDetailsAssociatedSims = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            associatedSims: updateObject(state.bulkDetails.associatedSims, {data: action.data})
        })
    })
}

const setBulkDetailsOffer = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            offer: updateObject(state.bulkDetails.offer, {data: action.data})
        })
    })
}

const setBulkDetailsLoading = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            [`${action.name}`]: updateObject(state.bulkDetails[`${action.name}`], {loading: action.loading})
        })
    })
}

const setBulkDetailsNotAssociatedSims = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            notAssociatedSims: updateObject(state.bulkDetails.notAssociatedSims, {data: action.data})
        })
    })
}

// Sets loading on the action buttons of associate/deassociate
const setBulkDetailsActionLoading = (state, action) => {
    return updateObject(state, {
        bulkDetails: updateObject(state.bulkDetails, {
            [`${action.name}`]: action.loading
        })
    })
}

const setSelectedTab = (state, action) => {
    return updateObject(state, {selectedTab: action.selectedTab});
}

const updateSimAssociate = (state, action) => {
    return updateObject(state, {
        bulkDetails:
            updateObject(state.bulkDetails, {
                bulk: updateObject(state.bulkDetails.bulk, {
                    content:
                        updateObject(state.bulkDetails.bulk.content,
                            {
                                simAssociate: parseInt(state.bulkDetails.bulk.content.simAssociate) + action.mieCount,
                                simConsociate: parseInt(state.bulkDetails.bulk.content.simConsociate) + action.consociataCount
                            })
                })
            })
    })
}

const setAddRemoveOptions = (state, action) => {
    return updateObject(state, {
        tokenOptions: updateObject(state.tokenOptions, {
            addOptions: action.data.addOptions,
            removeOptions: action.data.removeOptions
        })
    })
}

const setLoadingAddRemoveOptions = (state, action) => {
    return updateObject(state, {
        tokenOptions: updateObject(state.tokenOptions, {
            loading: action.value
        })
    })
}

const setDownloadCsvLoading = (state, action) => {
    return updateObject(state, {
        downloadCsvLoading: action.payload
    })
}

const digitalContractReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BULK_CARD_DATA:
            return setBulkCardData(state, action);
        case actionTypes.FETCH_PLAN_OPTIONS_FOR_SIM:
            return setPlanOptionsAndCurrentOffer(state, action);
        case actionTypes.SET_LOADING_PLAN_OPTIONS_FOR_SIM:
            return setLoadingPlanOptions(state, action);
        case actionTypes.FETCH_OFFER_FOR_NEW_PLAN:
            return setOfferForNewPlan(state, action);
        case actionTypes.SET_LOADING_OFFER_FOR_NEW_PLAN:
            return setLoadingOfferForNewPlan(state, action);
        case actionTypes.SET_LOADING_BULK_CARDS:
            return setLoadingBulkCards(state, action);
        case actionTypes.SET_BULK_DETAILS_CONTENT:
            return setBulkDetailsContent(state, action);
        case actionTypes.SET_BULK_DETAILS_ASSOCIATED_SIMS:
            return setBulkDetailsAssociatedSims(state, action);
        case actionTypes.SET_BULK_DETAILS_OFFER:
            return setBulkDetailsOffer(state, action);
        case actionTypes.SET_LOADING_BULK_DETAILS:
            return setBulkDetailsLoading(state, action);
        case actionTypes.FETCH_BULK_DETAILS_NOT_ASSOCIATED_SIMS:
            return setBulkDetailsNotAssociatedSims(state, action);
        case actionTypes.SET_BULK_DETAILS_ACTION_LOADING:
            return setBulkDetailsActionLoading(state, action);
        case actionTypes.FETCH_ADD_REMOVE_OPTIONS:
            return setAddRemoveOptions(state, action);
        case actionTypes.SET_LOADING_ADD_REMOVE_OPTIONS:
            return setLoadingAddRemoveOptions(state, action);
        case actionTypes.SET_SELECTED_TAB_EXTRA_SHARE:
            return setSelectedTab(state, action);
        case actionTypes.UPDATE_SIM_ASSOCIATE_BULK:
            return updateSimAssociate(state, action);
        case actionTypes.SET_BULK_CSV_DOWNLOAD_LOADING:
            return setDownloadCsvLoading(state, action)
        default:
            return state;
    }
};

export default digitalContractReducer;
